import useShortcut from 'common/utilities/hooks/useShortcut/useShortcut';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { Sequence, SequenceAlign } from 'sequenceAnalyser/api/sequenceAnalyserApiClient';
import type { HandleAlignedSequencesChange } from 'sequenceAnalyser/components/SequenceAnalyser/SequenceAnalyser';
import type { SequenceSelection } from 'sequenceAnalyser/utilities/selection/selection';
import { isSelectionGapsOnly, removeGapsFromSelectedSequences } from 'sequenceAnalyser/utilities/selectionActions/removeGaps';

function useShortcutDeleteGap(
  alignedSequences: SequenceAlign[],
  sequences: Sequence[],
  onAlignedSequencesChange: HandleAlignedSequencesChange,
) {
  const deleteGapTrigger = useShortcut('Backspace', false, { debounceTime: 50 });
  const selection = useSelector((state: ApplicationState) => state.sequenceAnalyser.selection);

  useEffect(() => {
    if (
      deleteGapTrigger
      && selection
      && selection.positionStart !== undefined && selection.positionEnd !== undefined
      && selection.positionStart === selection.positionEnd
    ) {
      if (!isSelectionGapsOnly(selection, alignedSequences, selection.positionEnd)) {
        return;
      }

      const { updatedAlignedSequences, updatedSequences } = removeGapsFromSelectedSequences(
        selection,
        alignedSequences,
        sequences,
      );

      const newSelection: SequenceSelection = {
        ...selection,
        positionStart: selection.positionStart === 0 ? selection.positionStart : selection.positionStart - 1,
        positionEnd: selection.positionEnd === 0 ? selection.positionEnd : selection.positionEnd - 1,
      };

      onAlignedSequencesChange(updatedAlignedSequences, updatedSequences, newSelection);
    }
  }, [alignedSequences, deleteGapTrigger, onAlignedSequencesChange, selection, sequences]);
}

export default useShortcutDeleteGap;
